import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OAuthFeatureConfig } from '@com-delta-idp/mnx-oauth';
import { TrackerModule } from '@com-delta-idp/mnx-skymiles-overview';
import {
  ErrorMessageComponent,
  TooltipComponent,
  TrackerComponent
} from '@com-delta-omnichannel/aura';
import { PushModule } from '@ngrx/component';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FlyoutTrackerComponent } from './flyout-tracker.component';

const oAuthFeatureConfig: OAuthFeatureConfig = {
  app: 'SKYMILES',
  endpointKey: 'SKYMILES_AEM_AUTH_CONFIG'
};

@NgModule({
  declarations: [FlyoutTrackerComponent],
  imports: [
    CommonModule,
    PushModule,
    TrackerComponent,
    ErrorMessageComponent,
    TooltipComponent,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    TrackerModule
  ],
  providers: [
    {
      provide: 'REDIRECT',
      useValue: false
    },
    {
      provide: 'OAUTH_FEATURE_CONFIG',
      useValue: oAuthFeatureConfig
    }
  ],
  exports: [FlyoutTrackerComponent]
})
export class FlyoutTrackerModule {}
